import React from 'react';
import Modal from 'components/Modal';
import Icon from 'components/Icon'
import ButtonRoundedSt from 'components/ButtonRoundedSt';
import { ResizeContext } from 'contexts/Resize';
import {
  Wrapper,
  ModalContent,
  Grabber,
  InfoBlock,
  Header,
  ImageWrapper,
  DynamicImageStyled,
  TextStyled,
  TextSmall,
  HintIconWrapper,
  Hint,
  ButtonContent,
  ButtonBox,
} from './styles'
import { css } from 'styled-components'
import PropTypes from 'prop-types'


const SubscriptionInfo = ({ paths, toggleModal, dict }) => {
  const { mobile } = React.useContext(ResizeContext);
  const Text = mobile ? TextSmall : TextStyled;
  const onClose = () => toggleModal(false);
  return (
    <Wrapper>
      <Modal
        modalOpen={true}
        handleCloseModal={onClose}
        isMobile={true}
        isOnBottom={true}
        position={mobile ? 'bottom' : 'right'}
        isRounded={true}
        closeOnOverlayClick={true}
      >
        <ModalContent>
          <Grabber />
          <Header dangerouslySetInnerHTML={{ __html: dict.title }} />
          <InfoBlock>
            <ImageWrapper>
              <DynamicImageStyled
                image={`${paths.shared}/cart/subscription_calendar`}
                namesByBreakpoints={false}
                imageType={'png'}
                fitOption="none"
                alt={'subscription calendar'}
                imageSizes={{
                  xs: 70,
                  md: 70,
                  lg: 70,
                }}
              />
            </ImageWrapper>
            <Text dangerouslySetInnerHTML={{ __html: dict.time_descr }} />
          </InfoBlock>
          <InfoBlock>
            <ImageWrapper>
              <DynamicImageStyled
                image={`${paths.shared}/cart/subscription_letter`}
                namesByBreakpoints={false}
                imageType={'png'}
                fitOption="none"
                alt={'subscription calendar'}
                imageSizes={{
                  xs: 70,
                  md: 70,
                  lg: 70,
                }}
              />
            </ImageWrapper>
            <Text dangerouslySetInnerHTML={{ __html: dict.payment_descr }} />
          </InfoBlock>
          <Hint>
            <HintIconWrapper><Icon id="btn_info" color="blackOp5" /></HintIconWrapper>
            <Text dangerouslySetInnerHTML={{ __html: dict.cancel_descr }} />
          </Hint>
          <ButtonBox>
            <ButtonRoundedSt
              as="button"
              bgStyles={css`
                background-color: ${p => p.theme.colors.black};
                width: 100%;
              `}
              size="fit"
              onClick={onClose}
            >
              <ButtonContent>
                <span dangerouslySetInnerHTML={{ __html: 'OK' }} />
              </ButtonContent>
            </ButtonRoundedSt>
          </ButtonBox>
        </ModalContent>
      </Modal>
    </Wrapper>
  )
}

export default SubscriptionInfo;

SubscriptionInfo.propTypes = {
  paths: PropTypes.object.isRequired,

  dict: PropTypes.object.isRequired,

  toggleModal: PropTypes.func.isRequired,
}
